import React from 'react';
import Loadable from 'react-loadable';
import { Redirect, Switch } from 'react-router-dom';
import EditableRoute from '@components/EditableRoute';

import LitigationPageWrapper from './components/PageWrapper';

const namespace = 'litigation';

const Loading = () => <div />;

const LitigationDashboard = Loadable({
  loader: () => import('./pages/dashboard'),
  loading: Loading,
});
const LitigationDashboardSearch = Loadable({
  loader: () => import('./pages/litigationDashboard/search'),
  loading: Loading,
});
const SOAHDashboardSearch = Loadable({
  loader: () => import('./pages/litigationDashboard/soahSearch'),
  loading: Loading,
});
const OfferSearch = Loadable({
  loader: () => import('./pages/litigationDashboard/offerSearch'),
  loading: Loading,
});
const LitigationDashboardCaseMaintenanceInfo = Loadable({
  loader: () => import('./pages/litigationDashboard/caseMaintenance/info'),
  loading: Loading,
});
const LitigationDashboardCaseCreationPage = Loadable({
  loader: () => import('./pages/litigationDashboard/caseMaintenance/create'),
  loading: Loading,
});
const LitigationDashboardMotionsDiscovery = Loadable({
  loader: () => import('./pages/litigationDashboard/motionsDiscovery'),
  loading: Loading,
});
const LitigationDashboardMotionMaintenance = Loadable({
  loader: () =>
    import(
      './pages/litigationDashboard/motionsDiscovery/MotionMaintenancePage'
    ),
  loading: Loading,
});
const LitigationDashboardOfferMaintenance = Loadable({
  loader: () =>
    import('./pages/litigationDashboard/motionsDiscovery/OfferMaintenancePage'),
  loading: Loading,
});
const LitigationDashboardDiscoveryMaintenance = Loadable({
  loader: () =>
    import(
      './pages/litigationDashboard/motionsDiscovery/DiscoveryMaintenancePage'
    ),
  loading: Loading,
});
const LitigationDashboardOffers = Loadable({
  loader: () => import('./pages/litigationDashboard/offers'),
  loading: Loading,
});
const LitigationDashboardDocuments = Loadable({
  loader: () => import('./pages/litigationDashboard/documents'),
  loading: Loading,
});
const LitigationDashboardDocumentMaintenance = Loadable({
  loader: () =>
    import('./pages/litigationDashboard/documents/DocumentMaintenance'),
  loading: Loading,
});
const LitigationDashboardEvidenceMaintenance = Loadable({
  loader: () =>
    import('./pages/litigationDashboard/documents/EvidenceMaintenancePage'),
  loading: Loading,
});
const LitigationDashboardCaseEvents = Loadable({
  loader: () => import('./pages/litigationDashboard/caseEvents'),
  loading: Loading,
});
const LitigationDashboardCadCommunications = Loadable({
  loader: () => import('./pages/litigationDashboard/cadCommunications'),
  loading: Loading,
});
const LitigationDashboardContactInformation = Loadable({
  loader: () => import('./pages/litigationDashboard/contactInformation'),
  loading: Loading,
});
const LitigationDashboardCadPartyMaintenace = Loadable({
  loader: () =>
    import(
      './pages/litigationDashboard/contactInformation/CadPartyMaintenancePage'
    ),
  loading: Loading,
});
const LitigationDashboardPlaintiffPartyMaintenace = Loadable({
  loader: () =>
    import(
      './pages/litigationDashboard/contactInformation/PlaintiffPartyMaintenancePage'
    ),
  loading: Loading,
});
const LitigationDashboardImpartialPartyMaintenace = Loadable({
  loader: () =>
    import(
      './pages/litigationDashboard/contactInformation/ImpartialPartyMaitenance'
    ),
  loading: Loading,
});
const LitigationDashboardContactMaintenance = Loadable({
  loader: () =>
    import(
      './pages/litigationDashboard/contactInformation/PartyMaintenancePage'
    ),
  loading: Loading,
});
const LitigationDashboardActivityLog = Loadable({
  loader: () => import('./pages/litigationDashboard/activityLog'),
  loading: Loading,
});
const LitigationDashboardRevisionHistory = Loadable({
  loader: () => import('./pages/litigationDashboard/revisionHistory'),
  loading: Loading,
});
const ArbitrationDashboardSearch = Loadable({
  loader: () => import('./pages/arbitrationDashboard/arbitrationSearch'),
  loading: Loading,
});
const ArbitrationDashboardCaseMaintenance = Loadable({
  loader: () => import('./pages/arbitrationDashboard/caseMaintenance'),
  loading: Loading,
});
const ArbitrationCasePrep = Loadable({
  loader: () => import('./pages/arbitrationDashboard/arbitrationCasePrep'),
  loading: Loading,
});
const ArbitrationEvents = Loadable({
  loader: () => import('./pages/arbitrationDashboard/arbitrationEvents'),
  loading: Loading,
});
const ArbitrationDisposition = Loadable({
  loader: () => import('./pages/arbitrationDashboard/arbitrationDisposition'),
  loading: Loading,
});
const ArbitrationComments = Loadable({
  loader: () => import('./pages/arbitrationDashboard/arbitrationComments'),
  loading: Loading,
});
const ArbitrationHearing = Loadable({
  loader: () => import('./pages/arbitrationDashboard/arbitrationHearing'),
  loading: Loading,
});
const ArbitrationDashboardMotionsDiscovery = Loadable({
  loader: () => import('./pages/arbitrationDashboard/motionsDiscovery'),
  loading: Loading,
});
const ArbitrationDashboardDocuments = Loadable({
  loader: () => import('./pages/arbitrationDashboard/documents'),
  loading: Loading,
});
const ArbitrationDashboardCaseEvents = Loadable({
  loader: () => import('./pages/arbitrationDashboard/caseEvents'),
  loading: Loading,
});
const ArbitrationDashboardCadCommunications = Loadable({
  loader: () => import('./pages/arbitrationDashboard/cadCommunications'),
  loading: Loading,
});
const ArbitrationDashboardContactInformation = Loadable({
  loader: () => import('./pages/arbitrationDashboard/contactInformation'),
  loading: Loading,
});
const ArbitrationDashboardActivityLog = Loadable({
  loader: () => import('./pages/arbitrationDashboard/activityLog'),
  loading: Loading,
});
const ArbitrationDashboardRevisionHistory = Loadable({
  loader: () => import('./pages/arbitrationDashboard/revisionHistory'),
  loading: Loading,
});
const ArbitrationCreate = Loadable({
  loader: () =>
    import('./pages/arbitrationDashboard/arbitrationCreate/walkThrough'),
  loading: Loading,
});
const LitigationPartySearch = Loadable({
  loader: () => import('./pages/partySearch'),
  loading: Loading,
});
const LitigationAppFunctions = Loadable({
  loader: () => import('./pages/appFunctions'),
  loading: Loading,
});
const LitigationMyArbitrationCases = Loadable({
  loader: () => import('./pages/arbitrationMyCases'),
  loading: Loading,
});
const LitigationMyCases = Loadable({
  loader: () => import('./pages/litigationDashboard/litigationMyCases'),
  loading: Loading,
});
const LitigationCodeFile = Loadable({
  loader: () => import('./pages/appSettings/codemaintenance'),
  loading: Loading,
});
const LitigationConfiguration = Loadable({
  loader: () => import('./pages/appSettings/configuration'),
  loading: Loading,
});
const LitigationFirmSearch = Loadable({
  loader: () => import('./pages/firmSearch'),
  loading: Loading,
});
const LitigationFirmMaintenance = Loadable({
  loader: () => import('./pages/litigationDashboard/firmMaintenance'),
  loading: Loading,
});
const LitigationArbitratorSearch = Loadable({
  loader: () => import('./pages/arbitratorSearch'),
  loading: Loading,
});
const LitigationArbitratorDetail = Loadable({
  loader: () => import('./pages/arbitratorDetail'),
  loading: Loading,
});

export const LitigationRoute = {
  Dashboard: `/${namespace}/dashboard`,
  LitigationCaseSearch: `/${namespace}/litigation-search`,
  LitigationCaseCreate: `/${namespace}/litigation-case-maintenance/create`,
  LitigationCaseEdit: `/${namespace}/litigation-case-maintenance/:id`,
  LitigationCaseMotions: `/${namespace}/litigation-motions-discovery/:id`,
  LitigationCaseMotionCreate: `/${namespace}/litigation-motions-discovery/:caseId/motion/create`,
  LitigationCaseMotionEdit: `/${namespace}/litigation-motions-discovery/:caseId/motion/:id`,
  LitigationCaseOfferCreate: `/${namespace}/litigation-motions-discovery/:caseId/offer/create`,
  LitigationCaseOfferEdit: `/${namespace}/litigation-motions-discovery/:caseId/offer/:id`,
  LitigationCaseOffers: `/${namespace}/litigation-offers/:id`,
  LitigationCaseDiscoveryCreate: `/${namespace}/litigation-motions-discovery/:caseId/discovery/create`,
  LitigationCaseDiscoveryEdit: `/${namespace}/litigation-motions-discovery/:caseId/discovery/:id`,
  LitigationCaseDocuments: `/${namespace}/litigation-documents/:id`,
  LitigationCaseDocumentCreate: `/${namespace}/litigation-documents/:caseId/document/create`,
  LitigationCaseDocumentEdit: `/${namespace}/litigation-documents/:caseId/document/:id`,
  LitigationCaseDocumentsCadEvidenceCreate: `/${namespace}/litigation-documents/:caseId/cad-evidence/create`,
  LitigationCaseDocumentsCadEvidenceEdit: `/${namespace}/litigation-documents/:caseId/cad-evidence/:id`,
  LitigationCaseDocumentsPlaintiffEvidenceCreate: `/${namespace}/litigation-documents/:caseId/plaintiff-evidence/create`,
  LitigationCaseDocumentsPlaintiffEvidenceEdit: `/${namespace}/litigation-documents/:caseId/plaintiff-evidence/:id`,
  LitigationCaseEvents: `/${namespace}/litigation-case-events/:id`,
  LitigationCaseCad: `/${namespace}/litigation-cad-communication/:id`,
  LitigationCaseContact: `/${namespace}/litigation-contact-information/:id`,
  LitigationCaseCadPartiesCreate: `/${namespace}/litigation-contact-information/:caseId/cad/create`,
  LitigationCaseCadPartiesEdit: `/${namespace}/litigation-contact-information/:caseId/cad/:id`,
  LitigationCasePlaintiffPartiesCreate: `/${namespace}/litigation-contact-information/:caseId/plaintiff/create`,
  LitigationCasePlaintiffPartiesEdit: `/${namespace}/litigation-contact-information/:caseId/plaintiff/:id`,
  LitigationCaseImpartialPartiesCreate: `/${namespace}/litigation-contact-information/:caseId/impartial/create`,
  LitigationCaseImpartialPartiesEdit: `/${namespace}/litigation-contact-information/:caseId/impartial/:id`,
  LitigationCaseContactCreate: `/${namespace}/litigation-party-maintenance/create`,
  LitigationCaseContactEdit: `/${namespace}/litigation-party-maintenance/:id`,
  LitigationCaseActivity: `/${namespace}/litigation-activity-log/:id`,
  LitigationCaseRevisionHistory: `/${namespace}/litigation-revision-history/:id`,
  ArbitrationCaseSearch: `/${namespace}/arbitration-search`,
  ArbitrationCaseCreate: `/${namespace}/arbitration/create`,
  ArbitrationCaseEdit: `/${namespace}/arbitration/:id`,
  ArbitrationCasePrep: `/${namespace}/arbitration/:id/caseprep`,
  ArbitrationEvents: `/${namespace}/arbitration/:id/events`,
  ArbitrationDisposition: `/${namespace}/arbitration/:id/disposition`,
  ArbitrationComments: `/${namespace}/arbitration/:id/comments`,
  ArbitrationHearing: `/${namespace}/arbitration/:id/hearing`,
  ArbitrationCaseMotions: `/${namespace}/arbitration-motions-discovery`,
  ArbitrationCaseDocuments: `/${namespace}/arbitration/:id/documents-evidence`,
  ArbitrationCaseEvents: `/${namespace}/arbitration-case-events`,
  ArbitrationCaseCad: `/${namespace}/arbitration-cad-communication`,
  ArbitrationCaseContact: `/${namespace}/arbitration-contact-information`,
  ArbitrationCaseActivity: `/${namespace}/arbitration-activity-log`,
  ArbitrationRevisionHistory: `/${namespace}/arbitration/:id/revision-history`,
  SOAHCaseSearch: `/${namespace}/soah-search`,
  OfferSearch: `/${namespace}/offer-search`,
  PartyCaseSearch: `/${namespace}/party-search`,
  AppFunctions: `/${namespace}/app-functions`,
  MyLitigationCases: `/${namespace}/my-litigation-cases`,
  MyArbitrationCases: `/${namespace}/my-arbitration-cases`,
  CodeFileMaintenance: `/${namespace}/code-file-maintenance`,
  Configuration: `/${namespace}/configuration`,
  FirmSearch: `/${namespace}/firm-search`,
  FirmMaintenance: `/${namespace}/firm/:firmID`,
  ArbitratorSearch: `/${namespace}/arbitrator-search`,
  ArbitratorEdit: `/${namespace}/arbitrator/:arbitratorID`,
};

export const LitigationPageTitle = {
  [LitigationRoute.Dashboard]: 'Dashboard',
  [LitigationRoute.LitigationCaseSearch]: 'Litigation Search',
  [LitigationRoute.LitigationCaseCreate]: 'Create Case',
  [LitigationRoute.LitigationCaseEdit]: 'View Case',
  [LitigationRoute.LitigationCaseMotions]: 'Motions & Discovery',
  [LitigationRoute.LitigationCaseMotionCreate]: 'Create Motion',
  [LitigationRoute.LitigationCaseMotionEdit]: 'Edit Motion',
  [LitigationRoute.LitigationCaseOfferCreate]: 'Create Offer',
  [LitigationRoute.LitigationCaseOfferEdit]: 'Edit Offer',
  [LitigationRoute.LitigationCaseOffers]: 'Offers',
  [LitigationRoute.LitigationCaseDiscoveryCreate]: 'Create Discovery',
  [LitigationRoute.LitigationCaseDiscoveryEdit]: 'Edit Discovery',
  [LitigationRoute.LitigationCaseDocuments]: 'Documents & Evidence',
  [LitigationRoute.LitigationCaseDocumentsCadEvidenceCreate]:
    'Create CAD Evidence',
  [LitigationRoute.LitigationCaseDocumentsCadEvidenceEdit]: 'Edit CAD Evidence',
  [LitigationRoute.LitigationCaseDocumentsPlaintiffEvidenceCreate]:
    'Create Plaintiff Evidence',
  [LitigationRoute.LitigationCaseDocumentsPlaintiffEvidenceCreate]:
    'Edit Plaintiff Evidence',
  [LitigationRoute.LitigationCaseEvents]: 'Case Events',
  [LitigationRoute.LitigationCaseCad]: 'CAD Communications',
  [LitigationRoute.LitigationCaseContact]: 'Parties',
  [LitigationRoute.LitigationCaseContactCreate]: 'Party Maintenance',
  [LitigationRoute.LitigationCaseContactEdit]: 'Party Maintenance',
  [LitigationRoute.LitigationCaseCadPartiesCreate]: 'CAD Party Maintenance',
  [LitigationRoute.LitigationCaseCadPartiesEdit]: 'CAD Party Maintenance',
  [LitigationRoute.LitigationCaseImpartialPartiesCreate]:
    'Impartial Party Maintenance',
  [LitigationRoute.LitigationCaseImpartialPartiesEdit]:
    'Impartial Party Maintenance',
  [LitigationRoute.LitigationCaseActivity]: 'Activity Log',
  [LitigationRoute.LitigationCaseRevisionHistory]: 'Revision History',
  [LitigationRoute.ArbitrationCaseSearch]: 'Arbitration Search',
  [LitigationRoute.ArbitrationCaseCreate]: 'Create Arbitration',
  [LitigationRoute.ArbitrationCaseEdit]: 'Arbitration Maintenance',
  [LitigationRoute.ArbitrationCasePrep]: 'Arbitration Case Prep',
  [LitigationRoute.ArbitrationEvents]: 'Arbitration Events',
  [LitigationRoute.ArbitrationDisposition]: 'Arbitration Disposition',
  [LitigationRoute.ArbitrationComments]: 'Arbitration Comments',
  [LitigationRoute.ArbitrationHearing]: 'Arbitration Hearing',
  [LitigationRoute.ArbitrationCaseMotions]: 'Motions & Discovery',
  [LitigationRoute.ArbitrationCaseDocuments]: 'Documents & Evidence',
  [LitigationRoute.ArbitrationCaseEvents]: 'Case Events',
  [LitigationRoute.ArbitrationCaseCad]: 'CAD Communications',
  [LitigationRoute.ArbitrationCaseContact]: 'Parties',
  [LitigationRoute.ArbitrationCaseActivity]: 'Activity Log',
  [LitigationRoute.ArbitrationRevisionHistory]: 'Revision History',
  [LitigationRoute.SOAHCaseSearch]: 'SOAH Search',
  [LitigationRoute.OfferSearch]: 'Offer Search',
  [LitigationRoute.PartyCaseSearch]: 'Search',
  [LitigationRoute.AppFunctions]: 'App Functions',
  [LitigationRoute.MyLitigationCases]: 'My Litigation Cases',
  [LitigationRoute.MyArbitrationCases]: 'My Arbitration Cases',
  [LitigationRoute.CodeFileMaintenance]: 'Code File Maintenance',
  [LitigationRoute.Configuration]: 'Configuration',
  [LitigationRoute.FirmSearch]: 'Search',
  [LitigationRoute.FirmMaintenance]: 'Firm Maintenance',
  [LitigationRoute.ArbitratorSearch]: 'Arbitrators Search',
  [LitigationRoute.ArbitratorEdit]: 'View Arbitrator',
};

const LitigationRoutes = props => (
  <LitigationPageWrapper {...props}>
    <Switch>
      <EditableRoute
        component={LitigationDashboard}
        exact
        path={LitigationRoute.Dashboard}
      />

      {/* Litigation Dashboard */}
      <EditableRoute
        key="litigationSearch"
        component={LitigationDashboardSearch}
        exact
        path={LitigationRoute.LitigationCaseSearch}
      />
      <EditableRoute
        component={LitigationDashboardCaseCreationPage}
        exact
        path={LitigationRoute.LitigationCaseCreate}
      />
      <EditableRoute
        component={LitigationDashboardCaseMaintenanceInfo}
        exact
        path={LitigationRoute.LitigationCaseEdit}
      />
      <EditableRoute
        component={LitigationDashboardMotionMaintenance}
        exact
        path={LitigationRoute.LitigationCaseMotionCreate}
      />
      <EditableRoute
        component={LitigationDashboardMotionMaintenance}
        exact
        path={LitigationRoute.LitigationCaseMotionEdit}
      />
      <EditableRoute
        component={LitigationDashboardOfferMaintenance}
        exact
        path={LitigationRoute.LitigationCaseOfferCreate}
      />
      <EditableRoute
        component={LitigationDashboardOfferMaintenance}
        exact
        path={LitigationRoute.LitigationCaseOfferEdit}
      />
      <EditableRoute
        component={LitigationDashboardOffers}
        exact
        path={LitigationRoute.LitigationCaseOffers}
      />
      <EditableRoute
        component={LitigationDashboardDiscoveryMaintenance}
        exact
        path={LitigationRoute.LitigationCaseDiscoveryCreate}
      />
      <EditableRoute
        component={LitigationDashboardDiscoveryMaintenance}
        exact
        path={LitigationRoute.LitigationCaseDiscoveryEdit}
      />
      <EditableRoute
        component={LitigationDashboardMotionsDiscovery}
        exact
        path={LitigationRoute.LitigationCaseMotions}
      />
      <EditableRoute
        component={LitigationDashboardDocuments}
        exact
        path={LitigationRoute.LitigationCaseDocuments}
      />
      <EditableRoute
        component={LitigationDashboardDocumentMaintenance}
        exact
        path={LitigationRoute.LitigationCaseDocumentCreate}
      />
      <EditableRoute
        component={LitigationDashboardDocumentMaintenance}
        exact
        path={LitigationRoute.LitigationCaseDocumentEdit}
      />
      <EditableRoute
        component={LitigationDashboardEvidenceMaintenance}
        exact
        path={LitigationRoute.LitigationCaseDocumentsCadEvidenceCreate}
      />
      <EditableRoute
        component={LitigationDashboardEvidenceMaintenance}
        exact
        path={LitigationRoute.LitigationCaseDocumentsCadEvidenceEdit}
      />
      <EditableRoute
        component={LitigationDashboardEvidenceMaintenance}
        exact
        path={LitigationRoute.LitigationCaseDocumentsPlaintiffEvidenceCreate}
      />
      <EditableRoute
        component={LitigationDashboardEvidenceMaintenance}
        exact
        path={LitigationRoute.LitigationCaseDocumentsPlaintiffEvidenceEdit}
      />
      <EditableRoute
        component={LitigationDashboardCaseEvents}
        exact
        path={LitigationRoute.LitigationCaseEvents}
      />
      <EditableRoute
        component={LitigationDashboardCadCommunications}
        exact
        path={LitigationRoute.LitigationCaseCad}
      />
      <EditableRoute
        component={LitigationDashboardContactInformation}
        exact
        path={LitigationRoute.LitigationCaseContact}
      />
      <EditableRoute
        component={LitigationDashboardContactMaintenance}
        exact
        path={LitigationRoute.LitigationCaseContactCreate}
      />
      <EditableRoute
        component={LitigationDashboardContactMaintenance}
        exact
        path={LitigationRoute.LitigationCaseContactEdit}
      />
      <EditableRoute
        component={LitigationDashboardCadPartyMaintenace}
        exact
        path={LitigationRoute.LitigationCaseCadPartiesCreate}
      />
      <EditableRoute
        component={LitigationDashboardCadPartyMaintenace}
        exact
        path={LitigationRoute.LitigationCaseCadPartiesEdit}
      />
      <EditableRoute
        component={LitigationDashboardPlaintiffPartyMaintenace}
        exact
        path={LitigationRoute.LitigationCasePlaintiffPartiesCreate}
      />
      <EditableRoute
        component={LitigationDashboardPlaintiffPartyMaintenace}
        exact
        path={LitigationRoute.LitigationCasePlaintiffPartiesEdit}
      />
      <EditableRoute
        component={LitigationDashboardImpartialPartyMaintenace}
        exact
        path={LitigationRoute.LitigationCaseImpartialPartiesCreate}
      />
      <EditableRoute
        component={LitigationDashboardImpartialPartyMaintenace}
        exact
        path={LitigationRoute.LitigationCaseImpartialPartiesEdit}
      />
      <EditableRoute
        component={LitigationDashboardActivityLog}
        exact
        path={LitigationRoute.LitigationCaseActivity}
      />
      <EditableRoute
        component={LitigationDashboardRevisionHistory}
        exact
        path={LitigationRoute.LitigationCaseRevisionHistory}
      />
      {/* Arbitration Dashboard */}
      <EditableRoute
        key="arbitrationSearch"
        component={ArbitrationDashboardSearch}
        exact
        path={LitigationRoute.ArbitrationCaseSearch}
      />
      <EditableRoute
        component={ArbitrationCreate}
        exact
        path={LitigationRoute.ArbitrationCaseCreate}
      />
      <EditableRoute
        component={ArbitrationDashboardCaseMaintenance}
        exact
        path={LitigationRoute.ArbitrationCaseEdit}
      />
      <EditableRoute
        component={ArbitrationCasePrep}
        exact
        path={LitigationRoute.ArbitrationCasePrep}
      />
      <EditableRoute
        component={ArbitrationEvents}
        exact
        path={LitigationRoute.ArbitrationEvents}
      />
      <EditableRoute
        component={ArbitrationDisposition}
        exact
        path={LitigationRoute.ArbitrationDisposition}
      />
      <EditableRoute
        component={ArbitrationComments}
        exact
        path={LitigationRoute.ArbitrationComments}
      />
      <EditableRoute
        component={ArbitrationHearing}
        exact
        path={LitigationRoute.ArbitrationHearing}
      />
      <EditableRoute
        component={ArbitrationDashboardMotionsDiscovery}
        exact
        path={LitigationRoute.ArbitrationCaseMotions}
      />
      <EditableRoute
        component={ArbitrationDashboardDocuments}
        exact
        path={LitigationRoute.ArbitrationCaseDocuments}
      />
      <EditableRoute
        component={ArbitrationDashboardCaseEvents}
        exact
        path={LitigationRoute.ArbitrationCaseEvents}
      />
      <EditableRoute
        component={ArbitrationDashboardCadCommunications}
        exact
        path={LitigationRoute.ArbitrationCaseCad}
      />
      <EditableRoute
        component={ArbitrationDashboardContactInformation}
        exact
        path={LitigationRoute.ArbitrationCaseContact}
      />
      <EditableRoute
        component={ArbitrationDashboardActivityLog}
        exact
        path={LitigationRoute.ArbitrationCaseActivity}
      />
      <EditableRoute
        component={ArbitrationDashboardRevisionHistory}
        exact
        path={LitigationRoute.ArbitrationRevisionHistory}
      />

      <EditableRoute
        key="soahSearch"
        component={SOAHDashboardSearch}
        exact
        path={LitigationRoute.SOAHCaseSearch}
      />

      <EditableRoute
        key="offerSearch"
        component={OfferSearch}
        exact
        path={LitigationRoute.OfferSearch}
      />

      <EditableRoute
        component={LitigationPartySearch}
        exact
        path={LitigationRoute.PartyCaseSearch}
      />
      <EditableRoute
        component={LitigationAppFunctions}
        exact
        path={LitigationRoute.AppFunctions}
      />
      <EditableRoute
        component={LitigationMyCases}
        exact
        path={LitigationRoute.MyLitigationCases}
      />
      <EditableRoute
        component={LitigationMyArbitrationCases}
        exact
        path={LitigationRoute.MyArbitrationCases}
      />
      <EditableRoute
        component={LitigationCodeFile}
        exact
        path={LitigationRoute.CodeFileMaintenance}
      />
      <EditableRoute
        component={LitigationConfiguration}
        exact
        path={LitigationRoute.Configuration}
      />
      <EditableRoute
        component={LitigationFirmSearch}
        exact
        path={LitigationRoute.FirmSearch}
      />
      <EditableRoute
        component={LitigationFirmMaintenance}
        exact
        path={LitigationRoute.FirmMaintenance}
      />
      <EditableRoute
        component={LitigationArbitratorSearch}
        exact
        path={LitigationRoute.ArbitratorSearch}
      />
      <EditableRoute
        component={LitigationArbitratorDetail}
        exact
        path={LitigationRoute.ArbitratorEdit}
      />
      <Redirect to={LitigationRoute.LitigationCaseSearch} />
    </Switch>
  </LitigationPageWrapper>
);

export default LitigationRoutes;
